import { useState } from 'react';
import Box from 'carbon-react/esm/components/box';
import Button from 'carbon-react/esm/components/button/__next__';
import Typography from 'carbon-react/esm/components/typography';

const ErrorThrower = ({ errorType }: { errorType: string | null }) => {
  if (errorType === 'render') {
    throw new Error('Debug: erreur de rendu simulée');
  }
  if (errorType === 'type') {
    throw new TypeError('Debug: TypeError simulée');
  }
  return null;
};

const DebugErrorTest = () => {
  const [errorType, setErrorType] = useState<string | null>(null);

  return (
    <Box p={20}>
      <div data-testid="debug-error-test-page">
        <Typography variant="h2" mb={3}>
          Test des ErrorBoundary
        </Typography>
        <Typography variant="p" mb={3}>
          {
            "Cliquez sur un bouton pour déclencher une erreur de rendu React capturée par l'ErrorBoundary englobant."
          }
        </Typography>
        <Box display="flex" gap={2} mt={3}>
          <Button
            onClick={() => setErrorType('render')}
            variantType="primary"
            variant="destructive"
          >
            Simuler une Error
          </Button>
          <Button
            onClick={() => setErrorType('type')}
            variantType="secondary"
            variant="destructive"
          >
            Simuler une TypeError
          </Button>
        </Box>
        <ErrorThrower errorType={errorType} />
      </div>
    </Box>
  );
};

export default DebugErrorTest;
